import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserSummary } from '../../services/user.service';
import { AuthService } from './auth.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { loginRedirectTo } from './login-redirect';

export const verificationGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const http = inject(HttpClient);

  if (!auth.isLoggedIn()) return loginRedirectTo(router, state.url);

  try {
    const user = await firstValueFrom(http.get<UserSummary>(`${environment.apiUrl}/api/auth/me`));
    if (!user.phoneVerified || !user.addressVerified) {
      return router.createUrlTree(['/verification-pending']);
    }
  } catch (err) {
    if (err instanceof HttpErrorResponse && err.status === 401) {
      return loginRedirectTo(router, state.url);
    }
  }

  return true;
};
